export default __webpack_public_path__ + "static/media/news-1.d6b00523.jpg";